<template>
  <el-avatar class="avatar" :size="size" :src="src">
    <div class="default">{{ placeholder }}</div>
  </el-avatar>
</template>

<script>
export default {
  name: 'avatar',
  props: {
    size: {
      type: Number,
      default: 40
    },
    src: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.avatar {
  flex-shrink: 0;
  .default {
    font-weight: bold;
    color: #FA2D48;
    background-color: #FFEEED;
  }
}
</style>
